module.exports = __webpack_public_path__ + "../resources/img/pictogram_batt.114564ac.png";